module.exports = __webpack_public_path__ + "static/media/anchors.9f11375e.svg";